<template>
    <v-text-field
        :label="$t(`filters.labels.${name}`)"
        clearable
        v-model="val"
        type="number"
    ></v-text-field>
</template>

<script>
export default {
    props: ['name', 'resource'],
    data() {
        return {
            val: undefined,
        }
    },
    watch: {
        val(val) {
            const setter = function() {
                if (val === this.val) {
                    this.$store.commit('filters/apply', {
                        resource: this.resource,
                        filter: { name: this.name, value: val },
                    })
                }
            }.bind(this)

            setTimeout(setter, 500)
        },
    },
}
</script>

<style></style>
